module.exports = __webpack_public_path__ + "officialStatic/img/case48.6061042.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case48.jpg
// module id = iIo1
// module chunks = 0